import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["mediaClientConfig"];
import React from 'react';
import { MediaClientContext, MediaClientProvider } from './MediaClientProvider';
export var withMediaClient = function withMediaClient(Component) {
  return function (_ref) {
    var mediaClientConfig = _ref.mediaClientConfig,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/React.createElement(MediaClientContext.Consumer, null, function (value) {
      return value ? /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
        mediaClient: value
      })) : /*#__PURE__*/React.createElement(MediaClientProvider, {
        clientConfig: mediaClientConfig
      }, /*#__PURE__*/React.createElement(MediaClientContext.Consumer, null, function (client) {
        return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
          mediaClient: client
        }));
      }));
    });
  };
};